import {
  Box,
  Fade,
  Image,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Img } from "../../../../content/Content";
import "./Banner.component.css";
import HeaderGap from "../../../../components/layouts/Header/HeaderGap";
const Banner = () => {
  const [langDrop, setLangDrop] = useState(false);

  const Lang = [
    {
      name: "English",
      flag: Img.us,
    },
    {
      name: "English (uk)",
      flag: Img.uk,
    },
    {
      name: "France ",
      flag: Img.france,
    },
    {
      name: "Germany",
      flag: Img.germany,
    },
  ];
  return (
    <VStack w="100%">
      <HeaderGap/>
      <VStack w="90%" mx="auto" justifyContent='flex-start' textAlign='left'>
        <Text
        w="100%"
        textAlign='left'                       
        fontFamily="'Roboto', sans-serif"
                      fontWeight="700"
                      fontSize={"40px"}
                      color="rgba(43, 44, 61, 1)">
          Dashboard
        </Text>
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        backgroundImage={Img.dashboardBg}
        bgSize={"cover"}
        bgRepeat="no-repeat"
        height={"248px"}
        className="bg_banner"
        w="100%"
        borderRadius="25px"
      >
        {/* desktop */}
        <Box w="100%" mx={"auto"} className="desktop-banner" px="35px">
          <Box >
            <Text
              fontFamily="'Roboto', sans-serif"
              fontWeight="700"
              fontSize="48px"
              lineHeight="1.1"
              color="#fff"
              paddingBottom="0"
              marginBottom="0"
            >
              Welcome to JIFU
            </Text>
            <Text               
              fontFamily="'Roboto', sans-serif"
              fontWeight="300"
              fontSize="36px" 
              color="rgba(255, 255, 255, 1)"
              >
              Elige un Idioma
            </Text>
          </Box>
          <Box display="flex" alignItems="center">
            <Text color="#fff">Choose a Language</Text>
            <Stack position="relative" w="115px" mx="5px">
              <Box
                bg={"rgba(240, 240, 250, 1)"}
                marginTop={"10px"}
                display="flex"
                alignItems="center"
                cursor="pointer"
                justifyContent="space-between"
                onClick={() => setLangDrop(!langDrop)}
                borderRadius="20px"
                padding={"8px 20px"}
                width={"152px"}
              >
                <Image
                  src={Img.us}
                  alt="photo"
                  w="28px"
                  h="28px"
                  borderRadius="25"
                />
                <Text
                  fontSize="20px"
                  fontWeight="400"
                  color="#rgba(0, 0, 0, 1)"
                  padding={"0"}
                  margin={"0"}
                >
                  English
                </Text>
              </Box>
              <Fade in={langDrop}>
                <Box
                  w="146px"
                  h="auto"
                  top="57px"
                  position="absolute"
                  left={"0"}
                  borderRadius="15px"
                  bg="white"
                  zIndex={"1111"}
                >
                  <UnorderedList
                    padding="0"
                    margin="0"
                    listStyleType="none"
                    display="flex"
                    alignItems="flex-start"
                    justifyContent={"center"}
                    flexDir="column"
                  >
                    {Lang.map((items) => {
                      return (
                        <ListItem padding="10px 10px" margin={"5px 0"}>
                          <Box
                            display="flex"
                            alignItems="center"
                            cursor="pointer"
                          >
                            <Image
                              src={items.flag}
                              alt="photo"
                              w="28px"
                              h="28px"
                              borderRadius="25"
                            />
                            <Text
                              fontSize="14px"
                              fontWeight="400"
                              margin="0 6px"
                              color="#000"
                            >
                              {items.name}
                            </Text>
                          </Box>
                        </ListItem>
                      );
                    })}
                  </UnorderedList>
                </Box>
              </Fade>
            </Stack>
          </Box>
        </Box>
      </Stack>
      </VStack>

    </VStack>
  );
};

export default Banner;
